import { gql } from 'apollo-angular';
import { CustomAttributeSection } from '../../entities/customAttributes/customAttributes';

export const UPDATE_CUSTOM_ATTRIBUTE_SECTION_MUTATION = gql`
mutation updateCustomAttributeSection($input: CustomAttributeSectionInput) {
  updateCustomAttributeSection(input: $input) {
    id
  }
}
`;

export const CREATE_CUSTOM_ATTRIBUTE_SECTION_MUTATION = gql`
mutation createCustomAttributeSection($input: CustomAttributeSectionInput) {
  createCustomAttributeSection(input: $input) {
    id
  }
}
`;

export const DELETE_CUSTOM_ATTRIBUTE_SECTION_MUTATION = gql`
mutation deleteCustomAttributeSection($id: UUID) {
  deleteCustomAttributeSection(id: $id)
}
`;

export const CUSTOM_ATTRIBUTE_SECTIONS_BY_ENTITY_QUERY = gql`
query getCustomAttributeSections($entity: String, $sortProperty: String, $sortDirection: String) {
  customAttributeSections: getCustomAttributeSections(
    filter: {
      entity: $entity,
      sortRequest: { sortProperties: [$sortProperty], sortDirection: $sortDirection }
    }
    ) {
    id
    externalId
    label
    index
    entity
    customAttributeDefinitions {
      id
      externalId
      customAttributeSection{
        id
      }
      entity
      type
      label
      index
      key
      conversionExpression
    }
  }
}
`;

export const UPDATE_CUSTOM_ATTRIBUTE_DEFINITION_MUTATION = gql`
mutation updateCustomAttributeDefinition($input: CustomAttributeDefinitionInput) {
  updateCustomAttributeDefinition(input: $input) {
    id
  }
}
`;

export const CREATE_CUSTOM_ATTRIBUTE_DEFINITION_MUTATION = gql`
mutation createCustomAttributeDefinition($input: CustomAttributeDefinitionInput) {
  createCustomAttributeDefinition(input: $input) {
    id
  }
}
`;

export const DELETE_CUSTOM_ATTRIBUTE_DEFINITION_MUTATION = gql`
mutation deleteCustomAttributeSection($id: UUID) {
  deleteCustomAttributeDefinition(id: $id)
}
`;

export interface CustomAttributeSectionsByEntityResponse {
  loading: boolean;
  customAttributeSections: CustomAttributeSection[];
}
